module.exports = __webpack_public_path__ + "img/comment-likes-counter.69960034.svg";